import { ElementSlider } from "thalia-molecules/modules";

export class OptionenSlider extends ElementSlider {
    constructor(container) {
        super(container);
        this.slider = container;
        this.component = this.slider.closest(".optionen-wrapper");
        this.setObservedElements();
        this.buttonPrevious = erzeugeKontrollelement("prev");
        this.buttonNext = erzeugeKontrollelement("next");
        this.touchEndgeraet = this.istTouchEndgeraet();
    }

    async init() {
        this.initSliderStartPosition();
        if (this.touchEndgeraet) return;
        this.slider.addEventListener("scroll", (event) => {
            this.scrollHandler(event);
        }, { once: true });
        await this.initKontrollelemente();
        this.initSliderObserver();
    }

    initSliderStartPosition(){
        const sliderPosition = this.slider.scrollLeft;
        const activeElement = this.slider.querySelector('[data-status="active"]');
        const activeSlideIndex = activeElement ? (activeElement.dataset.index || 0) : 0;
        this.slider.scrollTo({
            left: sliderPosition + this.singleEntryWidth * (activeSlideIndex - 1),
            behavior: "instant"
        });
    }

    setObservedElements() {
        this.erstesElement = this.slider.firstElementChild;
        this.letztesElement = this.slider.lastElementChild;
    }

    initPreconditionObserver() {
        const callback = (entries, observer) => this.preconditionObserverCallback(entries, observer);
        this.startIntersectionObserver([this.erstesElement, this.letztesElement], callback);
    }

    preconditionObserverCallback(entries, observer) {
        // Wenn das letzte Element der Liste nicht sichtbar ist,
        // initialiseren wir den Slider Observer
        for (const entry of entries) {
            const { intersectionRatio } = entry;
            if (intersectionRatio !== 1) {
                this.initSliderObserver();
            }
        }
        // Precondition Observer beenden
        return observer.disconnect();
    }

    initSliderObserver() {
        const observables = [this.erstesElement, this.letztesElement];
        const callback = (entries, observer) => this.sliderObserverCallback(entries, observer);
        this.sliderObserver = this.startIntersectionObserver(observables, callback);
    }

    sliderObserverCallback(entries, observer) {
        for (const entry of entries) {
            let button;
            const { target, intersectionRatio } = entry;
            const sliderEintragVollstaendigSichtbar = intersectionRatio === 1;
            const neuerButtonStatus = sliderEintragVollstaendigSichtbar ? "inaktiv" : "aktiv";
            switch (target) {
                case this.erstesElement:
                    button = this.buttonPrevious;
                    break;
                case this.letztesElement:
                    button = this.buttonNext;
                    break;
                default:
                    break;
            }
            if (!button || !neuerButtonStatus) return;
            button.setAttribute("data-status", neuerButtonStatus);
        }
    }

    istElementVollstaendigSichtbar(element) {
        const container = this.component || this.slider;
        const elementRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        return elementRect.left >= containerRect.left - 1 &&
               elementRect.right <= containerRect.right + 1;
    }

    // Kontrollelemente
    async initKontrollelemente(controlsHidden = false) {
        // Set initial button states based on current visibility
        const erstesElementSichtbar = this.istElementVollstaendigSichtbar(this.erstesElement);
        const letztesElementSichtbar = this.istElementVollstaendigSichtbar(this.letztesElement);

        this.buttonPrevious.setAttribute("data-status", erstesElementSichtbar ? "inaktiv" : "aktiv");
        this.buttonNext.setAttribute("data-status", letztesElementSichtbar ? "inaktiv" : "aktiv");

        const kontrollelemente = [this.buttonPrevious, this.buttonNext];
        for (const kontrollelement of kontrollelemente) {
            this.slider.insertAdjacentElement("afterend", kontrollelement);
            await this.setPositionTop(kontrollelement);
            kontrollelement.addEventListener("click", (event) => {
                this.kontrollelementKlickHandler(event);
            });
        }
    }

    kontrollelementKlickHandler(event) {
        const richtung = event.target.dataset["richtung"] || event.target.parentElement.dataset["richtung"];
        const sliderPosition = this.slider.scrollLeft;
        this.slider.scrollTo({
            left: sliderPosition + (richtung === "next" ? this.singleEntryWidth : - this.singleEntryWidth) * 2,
            behavior: "smooth"
        });
    }

    startIntersectionObserver(observables, callback) {
        if (!observables || !callback) return;
        const options = {
            root: this.component ? this.component : this.slider,
            threshold: [0.9, 0.95, 1.0]
        };
        const observer = new IntersectionObserver(callback, options);
        if (!observables.length) {
            observer.observe(observables);
        } else {
            for (const element of observables) {
                observer.observe(element);
            }
        }
        return observer;
    }


    istTouchEndgeraet() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobileUserAgent = regex.test(navigator.userAgent);

        const matchesMedia = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
        return isMobileUserAgent || matchesMedia;
    }
}

export function erzeugeKontrollelement(richtung) {
    const buttonwrapper = document.createElement("DIV");
    buttonwrapper.classList.add("tm-kontrollelement-wrapper");
    buttonwrapper.setAttribute("data-richtung", richtung);
    buttonwrapper.setAttribute("data-status", "aktiv");

    const text = richtung === "next" ? "rechts" : "links";
    const button = document.createElement("BUTTON");
    button.classList.add("element-button-tertiary-small-icon");
    button.classList.add("tm-kontrollelement");
    button.setAttribute("data-icon", richtung === "next" ? "right" : "left");
    button.setAttribute("interaction", `nach-${text}-scrollen`);
    button.dataset["richtung"] = richtung;
    button.innerText = `Nach ${text} scrollen`;
    buttonwrapper.appendChild(button);

    const icon = document.createElement("span");
    const iconclass = richtung === "next" ? "element-icon-chevron-rechts" : "element-icon-chevron-links";
    icon.classList.add(iconclass);
    button.appendChild(icon);

    return buttonwrapper;
}
